import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from '@feathr/components';
import { useStore } from '@feathr/extender/state';

import facebookPagesColumns from './facebookPagesColumns';

function FacebookPagesTable(): JSX.Element {
  const { FacebookPages } = useStore();
  const { t } = useTranslation();

  return (
    <Table
      collection={FacebookPages}
      columns={facebookPagesColumns(t)}
      noDataText={t('No pages found.')}
    />
  );
}

export default observer(FacebookPagesTable);
